import { IanaZone, IsoInstant } from '#.shared/dates/types.ts'
import { instantToDateTime } from '#.shared/dates/utils/convert.ts'
import z from 'zod'

import { AreaID } from '../../areas/models/area'
import { EmployeeID } from '../../employees/models/employee'
import { ShiftID } from '../../shifts/models/shift'
import { BreakDefinition } from '../../shifts/models/shiftBreakDefinition'
import { TimesheetEvent } from './timesheetEvent'

export const TimesheetID = z.string().brand<'TimesheetID'>()
export type TimesheetID = z.infer<typeof TimesheetID>

export const Timesheet = z
  .object({
    id: z.string(),
    time_zone_id: IanaZone,
    area_id: z.string(),
    employee_id: z.string(),
    shift_id: z.string().nullable(),
    expected_start_date: IsoInstant.nullable(),
    expected_end_date: IsoInstant.nullable(),
    start_event: z.object({
        data: TimesheetEvent.nullable(),
    }).optional(),
    end_event: z.object({
        data: TimesheetEvent.nullable(),
    }).optional(),
    features: z.object({
      break_adhoc_allowed: z.boolean(),
      geolocation_mode: z.string(),
    }),
    break_definitions: z.object({
      data: z.array(BreakDefinition),
    }),
  })
  .transform((obj) => ({
    id: TimesheetID.parse(obj.id),
    timeZoneId: obj.time_zone_id,
    areaId: AreaID.parse(obj.area_id),
    employeeId: EmployeeID.parse(obj.employee_id),
    shiftId: obj.shift_id ? ShiftID.parse(obj.shift_id) : null,
    expectedStartDate: obj.expected_start_date
      ? instantToDateTime(obj.expected_start_date, obj.time_zone_id)
      : null,
    expectedEndDate: obj.expected_end_date
      ? instantToDateTime(obj.expected_end_date, obj.time_zone_id)
      : null,
    startEvent: obj.start_event?.data ? obj.start_event.data : null,
    endEvent: obj.end_event?.data ? obj.end_event.data : null,
    features: obj.features,
    breakDefinitions: obj.break_definitions,
  }))

export type TimesheetSchema = z.input<typeof Timesheet>
export type Timesheet = z.output<typeof Timesheet>
